var SPiD = this.SPiD || {};

(function () {
    'use strict';

    SPiD.initToggler = function (trigger, target, i18n) {
        trigger.onclick = function () {
            if (trigger.innerHTML === i18n.show) {
                trigger.innerHTML = i18n.hide;
                SPiD.rmClass(target, 'hidden');
            } else {
                trigger.innerHTML = i18n.show;
                SPiD.addClass(target, 'hidden');
            }
            return false;
        };
        if (!trigger.innerHTML) {
            trigger.innerHTML = i18n.show;
        }
    };

    SPiD.initExpander = function (trigger, target) {
        SPiD.addClass(target, 'hidden');

        var handler = function (e) {
            e.preventDefault();
            SPiD.rmClass(target, 'hidden');
            trigger.removeEventListener('click', handler);
            trigger.parentNode.removeChild(trigger);
        };
        trigger.addEventListener('click', handler);
    };

    function initAll(ctx, elements, fn, i18n) {
        var target;
        for (var i = 0, l = elements.length; i < l; ++i) {
            target = ctx.querySelector(elements[i].getAttribute('href') ||
                                       elements[i].getAttribute('data-target'));
            if (target) {
                fn(elements[i], target, i18n);
            }
        }
    }

    SPiD.autoDisplay = function (ctx, i18n) {
        initAll(ctx, ctx.querySelectorAll('.toggler'), SPiD.initToggler, i18n.toggle);
        initAll(ctx, ctx.querySelectorAll('.expander'), SPiD.initExpander);
    };

}());
